<sim-basic-material-dialog (closeClicked)="close()" [finished]="finished" [matDialogData]="data" [rect]="rect">
	<div dialogContent>
		<div class="modal-header">
			<h4 class="modal-title">
				<i class="fas fa-th"></i>
				{{ T.TRAINING_ROOM_SELECT_ADD_ROOM | translate }}
			</h4>
		</div>
		<div class="modal-body">
			<div class="col-lg-12">
				<h3>
					{{ T.TRAINING_ROOM_SELECT_FROM_REGISTERED_ROOMS | translate }}
				</h3>
				<div class="registeredRoom">
					<div class="form-check registeredRoomContent">
						@for (trainingRoom of trainingRooms; track trainingRoom) {
							<mat-checkbox [(ngModel)]="trainingRoom.checked">
								{{ trainingRoom.name }}
							</mat-checkbox>
						}
					</div>
				</div>
			</div>

			<div class="clearfix"></div>
		</div>
	</div>

	<ng-container actions>
		<sim-button (onClick)="close()" [color]="'warn'" [icon]="{fontSet: 'fal', fontIcon: 'fa-times'}" [label]="T.BUTTON_CLOSE" />

		<sim-button (onClick)="ok()" [icon]="{fontSet: 'fad', fontIcon: 'fa-check'}" [label]="T.BUTTON_SAVE" [color]="'accent'" />
	</ng-container>
</sim-basic-material-dialog>
